import Vue from 'vue';
import Vuex from 'vuex';
import {axios} from "../plugins/http-axios";
import Uri, {uri} from "@/store/uri";
import error from "@/store/error";
import loader from "@/store/loader";
import system from "@/store/system";
import color from "@/store/color";
import i18n from "@/store/i18n";
import user from "@/store/user";
import bank from "@/store/bank";
import env from "@/store/env";
import paging from "@/store/paging";
import success from "@/store/success";
import requestFl from "@/store/requestFl";
import certificates from "@/store/certificates";
import questionnaire from "@/store/formBuilder";

Vue.use(Vuex);
export interface RootState {
    uri: Uri;
}

const store = new Vuex.Store<RootState>({
    state: {
        uri: uri,
    },
    mutations: {},
    actions: {
        logout({commit, dispatch, state}) {
            commit('setAuthorized');
            localStorage.clear();
            return axios.get(state.uri.logout)
                .then(() => {
                    return true;

                })
                .catch(e => {
                    e.uri = state.uri.logout;
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
    },
    getters: {
        uri: state => state.uri,
    },
    modules: {
        error,
        loader,
        system,
        color,
        i18n,
        user,
        bank,
        env,
        paging,
        success,
        requestFl,
        certificates,
        questionnaire,
    }
});


if (process.env.NODE_ENV !== 'production') {
    store.subscribeAction((action, state) => {
        console.warn('Action:', action.type, action.payload);
    });
    store.subscribe((mutation, state) => {
        console.warn('Mutation:', mutation.type, mutation.payload);
    });
}

export default store;
